import React from "react";
import Styles from './styles.module.scss'

import Seo from "../../components/_UI/seo";
import {useTranslation} from "react-i18next";
import TokenomicsS1 from "../../components/tokenomicsS1";
import TokenomicsS2 from "../../components/tokenomicsS2";
import TokenomicsS3 from "../../components/tokenomicsS3";



const TokenomicsPage = () => {
    const { t } = useTranslation();

    return (
        <section className={`${Styles.container}`}>
            <Seo title={t('Tokenomics')}/>
            <TokenomicsS1/>
            <TokenomicsS2/>
            <TokenomicsS3/>
        </section>
    );
};

export default TokenomicsPage;